import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IApp } from './../../../stores/AllStores';
const s = require('../../../styles/errors/errors');

// Component
@inject('store')
@observer
export class PageNotFound extends React.Component<IApp, {}> {
    constructor() {
        super();
    }

    public render() {
        return (
            <div className={s.pageNotFound}>
                <h1 className={s.pageNotFound__inner}>
                    404 Page not found
                </h1>
            </div>
        );
    }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/errors/PageNotFound/PageNotFound.tsx